module.exports = __webpack_public_path__ + "static/media/magnifying_glass.82b018bc.svg";